import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect } from 'react'

import { GtmEvents, SegmentEvents } from '@/configs/dataTrackingEvent'

////////////////////
// Google Tag Manager (GTM)

interface GtmEventDataType {
  event: GtmEvents
  [key: string]: string | number | undefined
}

export function trackGtmEvent(eventData: GtmEventDataType) {
  sendGTMEvent(eventData)
}

////////////////////
// Segment

const getPlatform = (): 'web' | 'web_ios' | 'web_android' => {
  if (/(iPhone)/i.test(navigator.userAgent)) return 'web_ios'
  if (/(Android)/i.test(navigator.userAgent)) return 'web_android'
  return 'web'
}

export const trackSegmentEvent = (event: SegmentEvents, opt = {}) => {
  const platform = getPlatform()

  const data = {
    platform,
    ...opt,
  }

  if (window.analytics) window.analytics.track(event, data)
}

export const useTrackSegmentEventWhenMount = (eventName: SegmentEvents, opt = {}) => {
  useEffect(() => {
    trackSegmentEvent(eventName, opt)
  }, [])
}
